<template>
    <div class="convention-obligations">
        <convention-sections-filters
            :cspFilters="cspFilters"
            :isAllCsp="convention.cspConfig.allIncluded"
            :convention="convention"
            @change="onCspFiltersChange"
        />
        <main-container>
            <v-row class="convention-sections">
                <v-col cols="3">
                    <convention-sections-menu :convention="convention" />
                </v-col>
                <v-col cols="9">
                    <convention-sections-table
                        v-if="sectionsContainer"
                        :container="sectionsContainer"
                        :convention="convention"
                        @select="onCoupleSelect"
                    />
                    <sep name="XL" />
                    <convention-sections
                        :cspFilters="cspFilters"
                        :convention="convention"
                        ref="sections"
                    />
                </v-col>
            </v-row>
        </main-container>
    </div>
</template>

<script>
import ConventionSectionsTable from "./table/ConventionSectionsTable.vue";
import ConventionSectionsFilters from "./filters/ConventionSectionsFilters.vue";
import ConventionSectionsMenu from "./menu/ConventionSectionsMenu.vue";
import ConventionSections from "./sections/ConventionSections.vue";
import scrollManager from "src/components/convention/managers/scrollManager";
import { EventBus } from "src/bus/eventBus";

import { head, get } from "lodash";

export default {
    components: {
        ConventionSections,
        ConventionSectionsMenu,
        ConventionSectionsFilters,
        ConventionSectionsTable,
    },
    props: ["convention"],
    data() {
        return {
            cspFilters: get(this.convention, "cspConfig.availableCodes", []),
            sectionsContainer: null,
            currentSelectedIds: null,
        };
    },
    mounted() {
        this.sectionsContainer = this.$refs.sections.$el;

        EventBus.$on("convention-sections:scrolled", m => {
            if (m == "table") this.currentSelectedIds = null;
        });
        EventBus.$on("convention-section-title:scrolled", i => (this.currentSelectedIds = i));
        this.$nextTick(() => this.scrollToSlug());
    },
    updated() {
        this.sectionsContainer = this.$refs.sections.$el;
    },
    methods: {
        onCspFiltersChange(cspFilters) {
            if (cspFilters.length > 0) {
                this.cspFilters = cspFilters;
                if (this.currentSelectedIds) {
                    const id = head(this.currentSelectedIds);
                    // Wait until content is updated on the page and then scroll
                    setTimeout(() => {
                        scrollManager.scrollToId(id);
                    }, 100);
                }
            }
        },
        onCoupleSelect({ filters, section }) {
            this.cspFilters = filters;
            this.$nextTick(() => scrollManager.scrollToSection(section));
        },
        scrollToSlug() {
            setTimeout(() => {
                if (this.$route.params.slug) {
                    scrollManager.scrollToId(this.$route.params.slug);
                } else {
                    scrollManager.scrollTop();
                }
            }, 500);
        },
    },
    watch: {
        $route() {
            this.scrollToSlug();
        },
        convention(newConvention, oldConvention) {
            if (oldConvention.id !== newConvention.id) {
                this.cspFilters = get(newConvention, "cspConfig.availableCodes", []);
                this.onCspFiltersChange(this.cspFilters);
            }
        },
    },
};
</script>

<style scoped lang="sass">
.convention-obligations
    background: $color-background
    padding: $grid-gutter/2 0

@media print
    .convention-obligations
        padding: 0
        background-color: transparent

    .convention-sections
        position: relative
        display: block
        margin: 3mm 0 0

    .col
        flex: 0 0 auto
        max-width: 100%
        width: auto
        padding: 0
</style>
